/* eslint-disable */
import * as React from "react";
import OrbitIcon from "../Icon";
export default function Attachment(props) {
  var color = props.color,
      size = props.size,
      customColor = props.customColor,
      className = props.className,
      dataTest = props.dataTest,
      ariaHidden = props.ariaHidden,
      ariaLabel = props.ariaLabel,
      reverseOnRtl = props.reverseOnRtl;
  return React.createElement(OrbitIcon, {
    viewBox: "0 0 24 24",
    size: size,
    color: color,
    customColor: customColor,
    className: className,
    dataTest: dataTest,
    ariaHidden: ariaHidden,
    reverseOnRtl: reverseOnRtl,
    ariaLabel: ariaLabel
  }, React.createElement("path", {
    d: "M20.235 4.822a5.833 5.833 0 0 0-8.235 0l-8.74 8.655c-1.68 1.68-1.68 4.454 0 6.135a4.26 4.26 0 0 0 6.05 0l7.06-7.06c1.092-1.008 1.176-2.772.168-3.949-1.009-1.176-2.773-1.176-3.95-.168l-.168.168-4.37 4.37a.812.812 0 0 0 0 1.176.812.812 0 0 0 1.177 0l4.37-4.37a1.065 1.065 0 0 1 1.512 0 1.065 1.065 0 0 1 0 1.513L8.05 18.351c-1.008 1.008-2.689 1.008-3.697 0s-1.008-2.689 0-3.697l8.824-8.656c1.596-1.597 4.285-1.597 5.882 0 1.597 1.597 1.597 4.286 0 5.882l-6.555 6.555a.812.812 0 0 0 0 1.177.812.812 0 0 0 1.177 0l6.554-6.555a5.686 5.686 0 0 0 0-8.235z"
  }));
}